import React from 'react';
import { func_cookieSetting, func_datetime, func_validation, isNumberValid, isStringTrimNotEmpty } from 'functions';

export function useMonthlyReportColumns(commissionType) {

    function getColumn_salesPersonCode() {
        let columnClassName = "columns__sales-person-code flex-fill";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Sales Person Code",
            id: "salesPersonCode",
            accessor: "AgentCode",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = value? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_docNo() {
        let columnClassName = "columns__doc-no flex-fill";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Doc No",
            id: "docNo",
            accessor: "DocNo",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = value? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_itemCode() {
        let columnClassName = "columns__item-code flex-fill";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Item Code",
            id: "itemCode",
            accessor: "ItemCode",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = value? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_docDate() {
        let columnClassName = "table__doc-date";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Doc Date",
            id: "docDate",
            accessor: "DocDate",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
                if (isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                    value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_completePaymentDate() {
        let columnClassName = "table__complete-payment-date";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Complete Payment Date",
            id: "completePaymentDate",
            accessor: "CompletePaymentDate",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
                if (isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                    value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 200
        }
    }

    function getColumn_description() {
        let columnClassName = "table__description";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Description",
            id: "description",
            accessor: "Description2",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_companyName() {
        let columnClassName = "table__company-name";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Company Name",
            id: "companyName",
            accessor: "CompanyName",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isStringTrimNotEmpty(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_salesPersonName() {
        let columnClassName = "columns__sales-person-name flex-fill";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Sales Person Name",
            id: "salesPersonName",
            accessor: "AgentName",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = value? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
        }
    }

    function getColumn_quantity() {
        let columnClassName = "columns__quantitu";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Quantity",
            id: "quantity",
            accessor: "Qty",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isNumberValid(value)? value: "-";
    
                return (
                    <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
                );
            },
            width: 150
        }
    }

    function getColumn_localAmount() {
        let columnClassName = "columns__local-amount";
    
        return {
            headerCellClassName: columnClassName + " ",
            Header: "Local Amount (RM)",
            id: "localAmount",
            accessor: "LocalAmount",
            bodyCellClassName: columnClassName + " ",
            Cell: (props) => {
                let value = props?.cell?.value;
                let value_formatted = isNumberValid(value)? value: "-";

                if (value_formatted != "-")
                    value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });
    
                return (
                    <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
                );
            },
            width: 175
        }
    }

    let completionColumn = [];
    switch (commissionType) {
        case "invoiceLevel1": case "invoiceLevel2":
            completionColumn.push(getColumn_completePaymentDate());
    }

    return [
        getColumn_salesPersonCode(),
        getColumn_salesPersonName(),
        getColumn_companyName(),
        getColumn_docNo(),
        getColumn_itemCode(),
        getColumn_docDate(),
        ...completionColumn,
        getColumn_description(),
        getColumn_quantity(),
        getColumn_localAmount(),
    ]
}